import { Work } from '@/core/models/Work'
import { GetterTree } from 'vuex'
import { IReviewState } from '.'
import { IRootState } from '@/store/'

export const getters: GetterTree<IReviewState, IRootState> = {}
